import React from 'react'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import FocusAtom from '../../@atoms/to_content/focus/focus.atom'
import {
  GridItemAtom,
  GridContainerAtom,
} from '../../@atoms/to_layout/grid/grid.atom'
import {
  AccordionSummaryAtom,
  AccordionDetailsAtom,
  AccordionAtom,
} from '../../@atoms/to_content/accordion/accordion.atom'

import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import StackAtom from '../../@atoms/to_layout/stack/stack.atom'
import ProgressBarAtom from '../../@atoms/to_forms/progressbar/progressbar.atom'

const DeliveryDetailComponent = function ({...props}) {
  const {
    arrivalExpectedDate,
    arrivalExpectedTime,
    deliveryCode,
    deliveryNote,
    id,
    storeStatus,
  } = props

  return (
    <AccordionAtom>
      <AccordionSummaryAtom id={id} ap_type="deliverySummary">
        <GridItemAtom xs={6} ap_type="gridAccordionTitle">
          <TypographyAtom ap_type="title">
            Visit: <FocusAtom>{deliveryCode}</FocusAtom>
          </TypographyAtom>
        </GridItemAtom>
        <GridItemAtom ap_type="gridAccordionTitle" xs={6}>
          <TypographyAtom ap_type="label1">View Details</TypographyAtom>
        </GridItemAtom>
      </AccordionSummaryAtom>
      <AccordionDetailsAtom ap_type="deliveryDetails">
        <GridContainerAtom ap_type="gridAccordionDetailsWrapper">
          <GridItemAtom xs={6} ap_type="gridAccordionDetails">
            <TypographyAtom ap_type="title">{storeStatus}</TypographyAtom>
            <TypographyAtom ahd_type="product">
              Expected Arival: {arrivalExpectedDate}
            </TypographyAtom>
            <TypographyAtom ap_type="body">
              {arrivalExpectedTime}
            </TypographyAtom>
          </GridItemAtom>
          <GridItemAtom xs={6} ap_type="gridAccordionDetails">
            <TypographyAtom ap_type="body2">{deliveryNote}</TypographyAtom>

            <StackAtom ap_type="row" justifyContent="flex-end">
              <BoxAtom>
                <ButtonAtom ap_type="secondary">Edit Instructions</ButtonAtom>
              </BoxAtom>
              <BoxAtom>
                <ButtonAtom ap_type="secondary">Change Date</ButtonAtom>
              </BoxAtom>
            </StackAtom>
          </GridItemAtom>
        </GridContainerAtom>

        <ProgressBarAtom
          ap_progress_status_arr={[
            'Ordered',
            'Booked',
            'Confirmed',
            'Out for Deliver',
            'Delivered',
          ]}
          ap_progress_step={1}
        />
      </AccordionDetailsAtom>
    </AccordionAtom>
  )
}

export default DeliveryDetailComponent
